//
//
//
//
//
//
//
//
//
//
//

import SpeakersPreview from '@/components/events/speakersPreview.vue';

export default {
  components: { SpeakersPreview },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
  },
};
